import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateTweetJson202,
  CreateTweetJsonBody,
  CreateTweetWithMedia202,
  CreateTweetWithMediaBody,
  GetTweetById200,
  GetTweetFeed200,
  GetTweetFeedParams,
  LikeTweet200,
  Retweet200
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get tweet feed
 */
export const getTweetFeed = (
    params?: GetTweetFeedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTweetFeed200>(
      {url: `https://api.ugot.uk/api/tweets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTweetFeedQueryKey = (params?: GetTweetFeedParams,) => {
    return [`https://api.ugot.uk/api/tweets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTweetFeedInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getTweetFeed>>, TError = unknown>(params?: GetTweetFeedParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTweetFeedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTweetFeed>>> = ({ signal }) => getTweetFeed(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTweetFeedInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTweetFeed>>>
export type GetTweetFeedInfiniteQueryError = unknown

/**
 * @summary Get tweet feed
 */
export const useGetTweetFeedInfinite = <TData = Awaited<ReturnType<typeof getTweetFeed>>, TError = unknown>(
 params?: GetTweetFeedParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTweetFeedInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTweetFeedQueryOptions = <TData = Awaited<ReturnType<typeof getTweetFeed>>, TError = unknown>(params?: GetTweetFeedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTweetFeedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTweetFeed>>> = ({ signal }) => getTweetFeed(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTweetFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getTweetFeed>>>
export type GetTweetFeedQueryError = unknown

/**
 * @summary Get tweet feed
 */
export const useGetTweetFeed = <TData = Awaited<ReturnType<typeof getTweetFeed>>, TError = unknown>(
 params?: GetTweetFeedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTweetFeed>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTweetFeedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new tweet (JSON)
 */
export const createTweetJson = (
    createTweetJsonBody: CreateTweetJsonBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateTweetJson202>(
      {url: `https://api.ugot.uk/api/tweets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTweetJsonBody
    },
      options);
    }
  


export const getCreateTweetJsonMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTweetJson>>, TError,{data: CreateTweetJsonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTweetJson>>, TError,{data: CreateTweetJsonBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTweetJson>>, {data: CreateTweetJsonBody}> = (props) => {
          const {data} = props ?? {};

          return  createTweetJson(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTweetJsonMutationResult = NonNullable<Awaited<ReturnType<typeof createTweetJson>>>
    export type CreateTweetJsonMutationBody = CreateTweetJsonBody
    export type CreateTweetJsonMutationError = void

    /**
 * @summary Create a new tweet (JSON)
 */
export const useCreateTweetJson = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTweetJson>>, TError,{data: CreateTweetJsonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createTweetJson>>,
        TError,
        {data: CreateTweetJsonBody},
        TContext
      > => {

      const mutationOptions = getCreateTweetJsonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new tweet with media files
 */
export const createTweetWithMedia = (
    createTweetWithMediaBody: CreateTweetWithMediaBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append('jsonData', createTweetWithMediaBody.jsonData)
if(createTweetWithMediaBody.mediaFiles !== undefined) {
 createTweetWithMediaBody.mediaFiles.forEach(value => formData.append('mediaFiles', value));
 }

      return customInstance<CreateTweetWithMedia202>(
      {url: `https://api.ugot.uk/api/tweets/with-media`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getCreateTweetWithMediaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTweetWithMedia>>, TError,{data: CreateTweetWithMediaBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTweetWithMedia>>, TError,{data: CreateTweetWithMediaBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTweetWithMedia>>, {data: CreateTweetWithMediaBody}> = (props) => {
          const {data} = props ?? {};

          return  createTweetWithMedia(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTweetWithMediaMutationResult = NonNullable<Awaited<ReturnType<typeof createTweetWithMedia>>>
    export type CreateTweetWithMediaMutationBody = CreateTweetWithMediaBody
    export type CreateTweetWithMediaMutationError = void

    /**
 * @summary Create a new tweet with media files
 */
export const useCreateTweetWithMedia = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTweetWithMedia>>, TError,{data: CreateTweetWithMediaBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createTweetWithMedia>>,
        TError,
        {data: CreateTweetWithMediaBody},
        TContext
      > => {

      const mutationOptions = getCreateTweetWithMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get tweet by ID
 */
export const getTweetById = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTweetById200>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTweetByIdQueryKey = (tweetId: string,) => {
    return [`https://api.ugot.uk/api/tweets/${tweetId}`] as const;
    }

    
export const getGetTweetByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getTweetById>>, TError = void>(tweetId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTweetByIdQueryKey(tweetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTweetById>>> = ({ signal }) => getTweetById(tweetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tweetId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTweetByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTweetById>>>
export type GetTweetByIdInfiniteQueryError = void

/**
 * @summary Get tweet by ID
 */
export const useGetTweetByIdInfinite = <TData = Awaited<ReturnType<typeof getTweetById>>, TError = void>(
 tweetId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTweetByIdInfiniteQueryOptions(tweetId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTweetByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTweetById>>, TError = void>(tweetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTweetByIdQueryKey(tweetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTweetById>>> = ({ signal }) => getTweetById(tweetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tweetId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTweetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTweetById>>>
export type GetTweetByIdQueryError = void

/**
 * @summary Get tweet by ID
 */
export const useGetTweetById = <TData = Awaited<ReturnType<typeof getTweetById>>, TError = void>(
 tweetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTweetById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTweetByIdQueryOptions(tweetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete a tweet
 */
export const deleteTweet = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTweetMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTweet>>, TError,{tweetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTweet>>, {tweetId: string}> = (props) => {
          const {tweetId} = props ?? {};

          return  deleteTweet(tweetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTweetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTweet>>>
    
    export type DeleteTweetMutationError = void

    /**
 * @summary Delete a tweet
 */
export const useDeleteTweet = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTweet>>,
        TError,
        {tweetId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTweetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Like a tweet
 */
export const likeTweet = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LikeTweet200>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}/like`, method: 'POST'
    },
      options);
    }
  


export const getLikeTweetMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof likeTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof likeTweet>>, TError,{tweetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof likeTweet>>, {tweetId: string}> = (props) => {
          const {tweetId} = props ?? {};

          return  likeTweet(tweetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LikeTweetMutationResult = NonNullable<Awaited<ReturnType<typeof likeTweet>>>
    
    export type LikeTweetMutationError = void

    /**
 * @summary Like a tweet
 */
export const useLikeTweet = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof likeTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof likeTweet>>,
        TError,
        {tweetId: string},
        TContext
      > => {

      const mutationOptions = getLikeTweetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Unlike a tweet
 */
export const unlikeTweet = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}/like`, method: 'DELETE'
    },
      options);
    }
  


export const getUnlikeTweetMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlikeTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unlikeTweet>>, TError,{tweetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlikeTweet>>, {tweetId: string}> = (props) => {
          const {tweetId} = props ?? {};

          return  unlikeTweet(tweetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnlikeTweetMutationResult = NonNullable<Awaited<ReturnType<typeof unlikeTweet>>>
    
    export type UnlikeTweetMutationError = void

    /**
 * @summary Unlike a tweet
 */
export const useUnlikeTweet = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlikeTweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof unlikeTweet>>,
        TError,
        {tweetId: string},
        TContext
      > => {

      const mutationOptions = getUnlikeTweetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Retweet a tweet
 */
export const retweet = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Retweet200>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}/retweet`, method: 'POST'
    },
      options);
    }
  


export const getRetweetMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retweet>>, TError,{tweetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retweet>>, {tweetId: string}> = (props) => {
          const {tweetId} = props ?? {};

          return  retweet(tweetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetweetMutationResult = NonNullable<Awaited<ReturnType<typeof retweet>>>
    
    export type RetweetMutationError = void

    /**
 * @summary Retweet a tweet
 */
export const useRetweet = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof retweet>>,
        TError,
        {tweetId: string},
        TContext
      > => {

      const mutationOptions = getRetweetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Undo retweet
 */
export const undoRetweet = (
    tweetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/tweets/${tweetId}/retweet`, method: 'DELETE'
    },
      options);
    }
  


export const getUndoRetweetMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoRetweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof undoRetweet>>, TError,{tweetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoRetweet>>, {tweetId: string}> = (props) => {
          const {tweetId} = props ?? {};

          return  undoRetweet(tweetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UndoRetweetMutationResult = NonNullable<Awaited<ReturnType<typeof undoRetweet>>>
    
    export type UndoRetweetMutationError = void

    /**
 * @summary Undo retweet
 */
export const useUndoRetweet = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoRetweet>>, TError,{tweetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof undoRetweet>>,
        TError,
        {tweetId: string},
        TContext
      > => {

      const mutationOptions = getUndoRetweetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    